import InvoiceList from '../components/InvoiceList'
import { useQuery } from 'react-query'
import { fetchInvoices } from '../../../api/api'
import { useChosenCompany } from '../../../context/UserProvider'
import type { InvoiceData } from '../../../types'

const Invoices = () => {
  const company = useChosenCompany()
  const companyId = company?.id

  const { data: response, status } = useQuery(['invoices', companyId], () => fetchInvoices(companyId), {
    enabled: !!companyId,
  })

  const data = (
    Array.isArray(response) ? response : response && 'data' in response ? response.data : []
  ) as InvoiceData[]

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col md:flex-row md:items-center gap-2 md:justify-between">
        <div className="flex flex-row justify-between items-center">
          <span className="text-xl font-medium text-primaryText">Fakturaer</span>
        </div>
      </div>

      <InvoiceList data={data} isLoading={status === 'loading'} />
    </div>
  )
}

export default Invoices
